import axios from 'axios';

const api = axios.create({
    // Vite dev server proxies or prod serves from same origin
    baseURL: '/api',
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json',
    },
});

export default api;
